import Nullstack from 'nullstack';
export default function IconBraile({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-braile",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M15 5a1 1 0 1 0 2 0a1 1 0 0 0 -2 0z"
  }), "   ", Nullstack.element("path", {
    d: "M7 5a1 1 0 1 0 2 0a1 1 0 0 0 -2 0z"
  }), "   ", Nullstack.element("path", {
    d: "M7 19a1 1 0 1 0 2 0a1 1 0 0 0 -2 0z"
  }), "   ", Nullstack.element("path", {
    d: "M16 12h.01"
  }), "   ", Nullstack.element("path", {
    d: "M8 12h.01"
  }), "   ", Nullstack.element("path", {
    d: "M16 19h.01"
  }), " ");
}